module.exports = __webpack_public_path__ + "img/tomato_sauce_start.84066339.jpg";